<script setup>
import { defineEmits, ref, watch } from 'vue';
import { useStore } from 'vuex';
import { generateQuote } from '../api/api';
import { pushToDataLayer } from '@/api/gtm';

const store = useStore();
const emit = defineEmits(['close']);
let email = '';
const quoteComplete = ref(false);
const loading_quote = ref(false);
const focusQuote = ref();
const gtmData = {
  'event' : 'Specsheet'
}
function close() {
    emit('close');
}

function quote() {
  loading_quote.value = true;
  generateQuote(store.state.specs, email).then(() =>  {
      pushToDataLayer(gtmData);
      quoteComplete.value = true;
      loading_quote.value = false;
  });
}

watch(
  () => store.state.quoteFormVisible,
  (visible) => {
    if (visible == true) {
      nextTick(()=>{
        focusQuote.value.focus();
      })
    // } else {
    //   nextTick(() => {
    //     document.getElementById('skipNav').focus();
    //   })
    // }
  }
});
</script>


<template>
    <div class="quote-wrapper">
        <div class="overlay-email" id="overlay-email" style="display:block;visibility:visible;border-radius:3px" ref="focusQuote" @click.stop="() => {}">
            <div class="close" @click="close">X</div>
            <div class="form" >
                <h2 class="quote-heading">Enter your email to receive your spec. sheet and quote!</h2>
                <div class="d-flex align-items-center w-100 justify-content-around flex-wrap">
                    <input v-model="email" class="form-control" placeholder="Email" style="flex-basis:70%;height:39px">
                    <button 
                        @click.stop="quote" 
                        class="quote-button"
                        style=""
                        >Send</button>

                </div>
            </div>
            <div class="message" v-show="quoteComplete">Your quote is complete, please check your email! </div>

        </div>
        <div class="loading-wrapper" v-show="loading_quote">
          <div class="loading-quote"  ref="loader" id="loading-animation"></div>
        </div>
    </div>

</template>

<style scoped lang="scss">
  .quote-heading {
    font-family:'Open Sans';
    font-weight:700;
    color:#1C5296;
    font-size:26px;
    margin-right:10px;
  }
    .loading-quote {
      background-image: url('https://springsfast.com/custom-springs-app/public/spring_loading.gif');
      height: 100%;
      width:100%;
      background-position: center center;
      background-size: 400px;
      background-repeat: no-repeat;
      position: absolute;
    }
    .loading-wrapper {
      background-color: rgb(33, 37, 41, .8);
      width:100%;
      height:100%;
      z-index: 9;
    }

.message {
    color:black;
    padding:1rem;
    font-weight:bold;
    font-family:'Open Sans';
    font-weight:600;
    font-size:18px;
    display: flex;
    align-items: center;
    justify-content: space-evenly;
}
.close {
    display: inline;
    color:black;

    position:absolute;
    right:0;
    top:0;
    font-size:1.5rem;
    font-weight: bold;
    padding:1rem;
    cursor:pointer;

}
.quote-wrapper {
  position:fixed;
  height:100vh;
  width:100vw;
  top:0;
  bottom:0;
  left:0;
  right:0;
  
  display: flex;
  flex-direction:row;
  width:100%;
  
  justify-content:center;
  align-items: center;
  background-color: rgb(33, 37, 41, .8);
  z-index: 999;
  
}
.form {
  
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 1 30%;
  flex-direction:column;
  color: white;
  flex-wrap: wrap;
  font-size:18px;
  font-weight:700
}
.overlay-email {
    background-color: white;
    padding:3rem;
    border-radius: var(--bs-border-radius);
    position: absolute;
}

.quote-button {
  color: white;
  font-weight: 700;
  font-family:'Open Sans';
  font-weight:600;
  color:#44961c;
  font-size:18px;
  background-color:rgba(68,150,28,.10);
  border: 1px solid #44961c;
  display:flex;
  align-items:center;
  justify-content:center;
  padding:5px;
  box-shadow:4px 4px 0px 0px rgba(16, 22, 13, .1);
  border-radius:3px
}
</style>